// extracted by mini-css-extract-plugin
export default {"content":"Levels_content__1iGe+","title":"Levels_title__U8VNy","level-btns-container":"Levels_level-btns-container__eOMPJ"};